<template>
    <div id="setup-tab-evo-container">
        <b-row>
            <b-col lg="3" md="3" sm="12"> 
                <MdEdit
                    v-bind:Label="$t('Shared.ClientId')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'client_id'"
                    v-bind:MaxLengthProp="120"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Id="'input_clientId'"
                    v-model="editableItem.clientId"
                    v-on:change="emitChanged"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12"> 
                <MdEdit
                    v-bind:Label="$t('PPDbSetup.ClientSecret')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'client_secret'"
                    v-bind:MaxLengthProp="120"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Id="'input_clientSecret'"
                    v-model="editableItem.clientSecret"
                    v-on:change="emitChanged"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'TabSetupEvo',
    props: {
        value: {
            Type: Object,
            default: null
        },
        isReadOnly: {
            Type: Boolean,
            default: false
        }
    },
    data() {
        const defaultItemData = {
            clientId: '',
            clientSecret: ''
        };
        return {
            editableItem: this.value || defaultItemData,
            defaultItemData: defaultItemData
        };
    },
    watch: {
        value(newVal) {
            this.editableItem = newVal || this.defaultItemData;
        },
        'editableItem.clientId'() {
            this.emitChanged();
        },
        'editableItem.clientSecret'() {
            this.emitChanged();
        }
    },
    methods: {
        emitChanged() {
            this.$emit('input', this.editableItem);
        }
    }
};
</script>
